module.exports = __webpack_public_path__ + "img/LogoAvalPay.2fe07347.png";